import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import RecentPostImg1 from "../Assets/img/blog/sm-img-1.jpg";
import RecentPostImg2 from "../Assets/img/blog/sm-img-2.jpg";
import RecentPostImg3 from "../Assets/img/blog/sm-img-3.jpg";
import BlogSingleImg from "../Assets/img/blog/img-1.jpg";
import CommentImg1 from "../Assets/img/blog/comments-img/img-1.png";
import CommentImg2 from "../Assets/img/blog/comments-img/img-2.png";
import CommentImg3 from "../Assets/img/blog/comments-img/img-3.png";

const BlogSingle = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">
                  Blog/Events Details
                </h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li>
                    <Link to="/blog">Blog/Events</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/blogsingle">Blog/Events Details</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-single-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-8 col-12">
              <div className="blog-single-main">
                <div className="blog-single-main-top">
                  <Link to="/blog" className="blog-single-main-top-btn">
                    <i className="fi fi-rs-arrow-left"></i>Back to blog
                  </Link>
                  <div className="blog-single-main-share">
                    <ul className="blog-single-main-share-list">
                      <li>Share:</li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-skype"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-whatsapp"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="blog-single-main-bottom">
                  <div className="blog-single-main-img">
                    <img src={BlogSingleImg} alt="#" />
                  </div>
                  <div className="blog-single-main-content">
                    <ul class="blog-single-meta-list">
                      <li>
                        <Link href="#">
                          <i class="fi fi-rr-alarm-clock"></i>November 05,2022
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <i class="fi fi-rr-user"></i>by Admin
                        </Link>
                      </li>
                    </ul>
                    <h3 className="blog-single-main-cont-title">
                      We Provide any Kind of Business and Creative Consultant
                      Solutions.
                    </h3>
                    <p className="blog-single-main-cont-text">
                      All users on MySpace will know that there are millions of
                      people out there. Every day besides so many people joining
                      this community, there are many others who will be looking
                      out for friends. This will mean that they are naturally
                      looking out for good people who are interesting enough.
                      For this, the profile has to be very interesting. on
                      MySpace will know that there are millions. Lorem ipsum
                      dolor sit amet, consectetur adipisicing elit, sed do
                      eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco.
                    </p>
                    <p className="blog-single-main-cont-text m-0">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidata.
                    </p>
                    <div className="blog-details-commnets">
                      <h4 className="blog-details-commnets-title">
                        Total Comments <span>(10)</span>
                      </h4>
                      <div className="blog-details-comt-inner">
                        <div className="blog-single-commnets">
                          <div className="blog-single-commnets-top">
                            <div className="blog-single-comnt-left">
                              <div className="blog-single-cmnt-img">
                                <img src={CommentImg1} alt="#" />
                              </div>
                              <div className="blog-single-comnt-tag">
                                <span className="blog-single-cmnt-date">
                                  <i className="fi fi-rr-calendar"></i>November
                                  05,2022
                                </span>
                                <h6 className="blog-single-cmnt-title">
                                  Jaedul Kabila
                                </h6>
                              </div>
                            </div>
                            <div className="blog-single-comnt-right">
                              <a href="#">
                                <i className="fi fi-ss-reply-all"></i>Reply
                              </a>
                            </div>
                          </div>
                          <div className="blog-single-comnt-bottom">
                            <p className="blog-single-comnt-bottom-text">
                              it is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout. The point of using
                              Lorem Ipsum is that it has a more-or-less normal
                              distribution of letters, as opposed to using
                              'Content here, content here', making it look like
                              readable English.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="blog-single-commnets single-comnt-list">
                          <div className="blog-single-commnets-top">
                            <div className="blog-single-comnt-left">
                              <div className="blog-single-cmnt-img">
                                <img src={CommentImg2} alt="#" />
                              </div>
                              <div className="blog-single-comnt-tag">
                                <span className="blog-single-cmnt-date">
                                  <i className="fi fi-rr-calendar"></i>November
                                  05,2022
                                </span>
                                <h6 className="blog-single-cmnt-title">
                                  Jaccia Islam
                                </h6>
                              </div>
                            </div>
                            <div className="blog-single-comnt-right">
                              <a href="#">
                                <i className="fi fi-ss-reply-all"></i>Reply
                              </a>
                            </div>
                          </div>
                          <div className="blog-single-comnt-bottom">
                            <p className="blog-single-comnt-bottom-text">
                              it is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout. The point of using
                              Lorem Ipsum is that it has a more-or-less normal
                              distribution of letters, as opposed to using
                              'Content here, content here', making it look like
                              readable English.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="blog-single-commnets">
                          <div className="blog-single-commnets-top">
                            <div className="blog-single-comnt-left">
                              <div className="blog-single-cmnt-img">
                                <img src={CommentImg3} alt="#" />
                              </div>
                              <div className="blog-single-comnt-tag">
                                <span className="blog-single-cmnt-date">
                                  <i className="fi fi-rr-calendar"></i>November
                                  05,2022
                                </span>
                                <h6 className="blog-single-cmnt-title">
                                  Meheraj Chowdhory
                                </h6>
                              </div>
                            </div>
                            <div className="blog-single-comnt-right">
                              <a href="#">
                                <i className="fi fi-ss-reply-all"></i>Reply
                              </a>
                            </div>
                          </div>
                          <div className="blog-single-comnt-bottom">
                            <p className="blog-single-comnt-bottom-text">
                              it is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout. The point of using
                              Lorem Ipsum is that it has a more-or-less normal
                              distribution of letters, as opposed to using
                              'Content here, content here', making it look like
                              readable English.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="blog-details-form">
                  <form action="#" method="post">
                    <div className="blog-details-form-box">
                      <div className="blog-details-form-top">
                        <h3 className="blog-details-form-title">
                          Post a comments
                        </h3>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                          <div className="form-group">
                            <input
                              name="name"
                              placeholder="Your name"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12">
                          <div className="form-group">
                            <input
                              name="email"
                              placeholder="Your email"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <textarea
                              name="message"
                              placeholder="Your comments"
                              required="required"
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="blog-details-form-btn">
                            <button type="submit" className="comnt-form-btn">
                              Post comment
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-4 col-12">
              <div className="blog-sidebar-area">
                <div className="blog-sidebar-widget seacrh-bar">
                  <form action="#" method="post">
                    <input type="text" placeholder="Search" required />
                    <button type="submit" className="seacrh-bar-btn">
                      <i className="fi fi-rr-search"></i>
                    </button>
                  </form>
                </div>
                <div className="blog-sidebar-widget sidebar-topic">
                  <h4 className="b-sidebar-widget-title">Topics</h4>
                  <ul className="sidebar-topic-list">
                    <li>
                      <Link to="#">
                        {" "}
                        Blogs<span>20</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {" "}
                        Events<span>10</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {" "}
                        Education<span>14</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {" "}
                        Cultural<span>8</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-sidebar-widget recents-post">
                  <h4 className="b-sidebar-widget-title">Recent posts</h4>
                  <div className="blog-sid-recent-post-inner">
                    <div className="blog-sid-recent-post-single">
                      <div className="blog-sid-recent-img">
                        <img src={RecentPostImg1} alt="#" />
                      </div>
                      <div className="blog-sid-recent-content">
                        <ul className="blog-sid-recent-cont-list">
                          <li>
                            <Link to="#">
                              <i class="fi fi-rr-calendar"></i>
                              November 03,2022
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i class="fi fi-rs-calendar-clock"></i>
                              Events
                            </Link>
                          </li>
                        </ul>
                        <h6 className="blog-sid-recent-cont-title">
                          Toanmisra mission critical action life items rather
                          Gotan
                        </h6>
                        <Link to="#" className="blog-sid-recent-cont-btn">
                          Read More<i className="fi fi-rs-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="blog-sid-recent-post-single">
                      <div className="blog-sid-recent-img">
                        <img src={RecentPostImg2} alt="#" />
                      </div>
                      <div className="blog-sid-recent-content">
                        <ul className="blog-sid-recent-cont-list">
                          <li>
                            <Link to="#">
                              <i class="fi fi-rr-calendar"></i>
                              November 03,2022
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i class="fi fi-rs-calendar-clock"></i>
                              Blog
                            </Link>
                          </li>
                        </ul>
                        <h6 className="blog-sid-recent-cont-title">
                          Repurpose mission critical action life items rather
                          total linkagesuds
                        </h6>
                        <Link to="#" className="blog-sid-recent-cont-btn">
                          Read More<i className="fi fi-rs-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="blog-sid-recent-post-single">
                      <div className="blog-sid-recent-img">
                        <img src={RecentPostImg3} alt="#" />
                      </div>
                      <div className="blog-sid-recent-content">
                        <ul className="blog-sid-recent-cont-list">
                          <li>
                            <Link to="#">
                              <i class="fi fi-rr-calendar"></i>
                              November 03,2022
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i class="fi fi-rs-calendar-clock"></i>
                              Events
                            </Link>
                          </li>
                        </ul>
                        <h6 className="blog-sid-recent-cont-title">
                          Toanmisra mission critical action life items rather
                          Gotan
                        </h6>
                        <Link to="#" className="blog-sid-recent-cont-btn">
                          Read More<i className="fi fi-rs-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogSingle;
